import { PaginationProps } from '@common/types/service';
import { State } from '@common/types/states';
import { api } from '@services/api';

const statesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getStates: builder.query<State[], { country: string; ordering?: PaginationProps['ordering'] }>({
            query: ({ country, ordering }) => ({
                url: 'public/states/',
                params: {
                    country,
                    ordering,
                },
            }),
            providesTags: ['States'],
        }),
    }),
});

export const { useGetStatesQuery } = statesApi;
export default statesApi;
